import axios from "axios";
import {SERVER_DOMAIN, LOGIN_URL, PUBLIC_URL} from './cons'
import dayjs from "dayjs";

class RequestHelper {
    constructor() {
        this.BASE_URL = SERVER_DOMAIN;
        this.conf = null;
    }

    parseCookie() {
        return document.cookie.split('; ').reduce((prev, current) => {
            const [name, ...value] = current.split('=');
            prev[name] = value.join('=');
            return prev;
        }, {});
    }

    setCookie() {
        const cookie = this.parseCookie();
        const cookieName = 'token';
        const cookieValue = cookie.token;
        if (!cookie.token) {
            throw new EvalError("Cookie không tồn tại");
        }
        var myDate = new Date();
        myDate.setDate(myDate.getDate + 3);
        document.cookie = `${cookieName}=${cookieValue};expires=${myDate};donamin=.${SERVER_DOMAIN};path=/`;
        this.conf = {headers: {Authorization: `Bearer ${cookie.token}`}}
    }

    /**
     *
     * @param {function} func hàm gọi
     * @param {array} args danh sách tham số
     * @returns giá trị nhận được từ server
     */
    wrapperExcute = async (func, args) => {
        const masks = document.getElementById('mask');
        try {
            if (this.startRequest) this.startRequest();
            masks.style.visibility = "visible";
            const cookie = this.parseCookie();
            let axiosConfig = {
                headers: {
                    'Authorization': cookie.token,
                }
              };
            args.timeout = 1000*60*10;
            let response = await func(...args, axiosConfig);
            return response.data;
        } catch(ex) {
            this.handleError(ex);
        }
        finally {
            masks.style.visibility = "hidden";
            if (this.stopRequest) this.stopRequest();
        }
    }

    handleError(ex) {
        if (ex instanceof EvalError) {
            window.location.href = LOGIN_URL;
        }
        if (ex.response.status === 401) {
            window.location.href = LOGIN_URL;
            return;
        }
        if (ex.response.status === 404) {
            this.onError("Xin lỗi! Đường dẫn truy cập không tồn tại!");
            return;
        }
        if (ex.response.status === 500) {
            this.onError("Xin lỗi! Có lỗi hệ thống. Vui lòng thông báo với quản trị viên để biết thông báo về lỗi này.");
            return;
        }
        this.onError(ex.response.message);
        //throw ex;
    }

    /**
     * Get an object by url
     * @param {String} url url
     * @param {Object} query object query
     * @returns get json data
     */
    get = async (url, query=null) => {
        var queryString = query == null ? "" : Object.keys(query).map(key => key + '=' + query[key]).join('&');
        queryString = !queryString ? "" : '?' + queryString;
        return await this.wrapperExcute(axios.get, [this.BASE_URL + url + queryString]);
    }

    /**
     * Gọi api edit
     * @param {string} url đường dẫn
     * @param {Object} postData dữ liệu post
     * @returns giá trị sau khi post
     */
    post = async(url, postData) => {
        return await this.wrapperExcute(axios.post, [this.BASE_URL + url, postData]);
    }

    /**
     * Gọi api add
     * @param {string} url đường dẫn
     * @param {Object} postData dữ liệu post
     * @returns giá trị sau khi post
     */
    put = async(url, putData) => {
        return await this.wrapperExcute(axios.put, [this.BASE_URL + url, putData]);
    }

    /**
     * Gọi api delete
     * @param {string} url đường dẫn
     * @param {Object} id dữ liệu dòng muốn xoá
     * @returns giá trị sau khi post
     */
    delete = async(url) => {
        return await this.wrapperExcute(axios.delete, [this.BASE_URL + url]);
    }

    download = async(url, query, preFileName = "") => {
        try {
            var queryString = query == null ? "" : Object.keys(query).map(key => key + '=' + query[key]).join('&');
            queryString = !queryString ? "" : '?' + queryString;
            const cookie = this.parseCookie();
            const response = await axios.get(this.BASE_URL + url + queryString, {
                headers: {
                    'Authorization': cookie.token,
                },
                responseType: 'blob'
            });
            const downloadURL = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = downloadURL;

            let fileName =`${preFileName}_${dayjs(new Date()).format("YYYYMMDD")}.xlsx`;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
        } catch (ex) {
            this.handleError(ex);
        }
    }
}

const requestHelper = new RequestHelper();

export default requestHelper;